import Vue from 'vue';
import App from './App.vue';
import store from './store';

import './plugins/axios';
import './registerServiceWorker';

import axios from 'axios';
import router from './router';

import vueCkEditor from 'ckeditor4-vue';
import vueMoment from 'vue-moment';
import vueDaumPostcode from "vue-daum-postcode"

import vueDragula from 'vue-dragula'
import uploadImage from '../src/components/uploadImage';

Vue.prototype.$Axios = axios;
Vue.config.productionTip = false;

Vue.use(vueCkEditor);
Vue.use(vueDaumPostcode);
Vue.use(vueMoment);
Vue.use(vueDragula);

Vue.component(uploadImage.name, uploadImage);

new Vue({
  router,
  store,
  render: h => h(App),
  data: {
    dragula: Vue.vueDragula
  },
}).$mount(`#app`)
